var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { Card, CardContent, Typography, IconButton } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import Preview from '@Assets/preview-account.jpeg';
import Container from "@Components/Container";
export default function CardPreview(_a) {
    var color = _a.color, textColor = _a.textColor, logo = _a.logo;
    var _b = useState(false), showBalance = _b[0], setShowBalance = _b[1];
    return (_jsxs(Container, __assign({ width: "70%", height: "700px", style: { position: 'relative' } }, { children: [_jsx("img", { src: Preview, alt: "Preview", style: {
                    width: '100%',
                    height: '100%',
                    objectFit: 'contain',
                } }), _jsx(Card, __assign({ sx: {
                    width: '51%',
                    height: '21%',
                    borderRadius: '8px',
                    backgroundColor: color,
                    position: 'absolute',
                    top: '17.5%',
                    left: '24%',
                    zIndex: 2,
                    //           overflow: hidden;
                    // width: 82%;
                    // height: 21%;
                    // border-radius: 8px;
                    // background-color: #b6ff5c;
                    // position: absolute;
                    // top: 17.5%;
                    // left: 8%;
                    // z-index: 2;
                } }, { children: _jsxs(CardContent, { children: [_jsx(Typography, __assign({ variant: "body2", sx: { display: "flex", alignItems: "center", color: textColor } }, { children: "Saldo disponible" })), _jsxs(Typography, __assign({ variant: "h6", sx: { display: "flex", alignItems: "center", color: textColor } }, { children: ["$ ", showBalance ? "1,234.56" : "-------", _jsx(IconButton, __assign({ onClick: function () { return setShowBalance(!showBalance); }, size: "small" }, { children: showBalance ? _jsx(VisibilityOff, { sx: { color: textColor } }) : _jsx(Visibility, { sx: { color: textColor } }) }))] })), _jsx(Typography, __assign({ variant: "body2", color: "textSecondary", sx: { mt: 1, color: textColor } }, { children: "Banco de Loja" })), _jsxs(Typography, __assign({ variant: "body2", sx: { display: "flex", justifyContent: "space-between", position: "relative", color: textColor } }, { children: [showBalance ? "987654321" : "--------", logo && (_jsx("img", { src: logo, alt: "Logo", style: {
                                        position: "absolute",
                                        right: '-60px',
                                        bottom: '10px',
                                        width: '185px',
                                        height: '100px',
                                        objectFit: "contain",
                                        opacity: 0.1,
                                    } })), _jsx(Typography, __assign({ component: "span", fontWeight: "bold", sx: {
                                        position: "absolute",
                                        right: 0,
                                        bottom: '-8px',
                                        zIndex: 1,
                                        color: textColor
                                    } }, { children: "Ahorros" }))] }))] }) }))] })));
}
